import { useEffect, useRef, useState } from "react";
import Confetti from "react-confetti";
import style from "../css/NumberRain.module.css";
import UAParser from "ua-parser-js";
import { offerEvent, updateFanduPoints } from "../../../utils/api";
import { ErrorHandling } from "../../../State";
import catch1 from "../../../icons/catch.webp";
import FanduEarnBanner from "./FanduEarnBanner";
import logo from "../../../icons/logoFanduW.svg";

function NumberRain({
  autoStart = false,
  onClose,
  page = "Quiz_Categories",
  isContest,
  remark,
  time,
}) {
  let mId = localStorage.getItem("mId") || "2026";
  let uuid = localStorage.getItem("uuid");

  let session_id = localStorage.getItem("session_id");

  let userId = localStorage.getItem("userId");

  const [open, setOpen] = useState(false);

  const [numbers, setNumbers] = useState([]);
  const [score, setScore] = useState(0);

  const [timeLeft, setTimeLeft] = useState(time);
  const [gameOver, setGameOver] = useState(false);

  const [rule, setRule] = useState(null);

  const containerRef = useRef();
  const totalTapsRef = useRef(0);
  const correctRef = useRef(0);

  const offerRequestData = (eventMetaData) => {
    try {
      const parser = new UAParser();

      const result = parser.getResult();

      return {
        machine_id: mId || "",
        device_id: uuid || "",
        session_id: session_id || "",
        ip_address: localStorage.getItem("ip_address") || "",
        lat: "",
        lng: "",
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        firstname: "",
        lastname: "",
        email: "",
        phone: "",
        deviceBrand: result?.device?.vendor || "Unknown",
        deviceModel: result?.device?.model || "Unknown",
        deviceType: result?.device?.type || "desktop",
        osName: result?.os?.name || "Unknown",
        osVersion: result?.os?.version || "Unknown",
        browserName: result?.browser?.name || "Unknown",
        browserVersion: result?.browser?.version || "Unknown",
        event_ts: Date.now().toString(),
        user_id: userId || "",
        ...eventMetaData,
      };
    } catch (error) {
      ErrorHandling("Unable to collect device information");

      return null;
    }
  };

  const avail = async (EventName, EventSubName, EventType, EventSubType) => {
    try {
      const requestData = offerRequestData({
        Event_Name: EventName,
        Event_Sub_Name: EventSubName,
        Event_Type: EventType,
        Event_Sub_Type: EventSubType,
      });

      if (!requestData) return;

      await offerEvent(requestData);
    } catch (error) {
      console.log("Offer Event Error:", error);
    }
  };

  const rewardNumberRainPoints = async (correct, totalTaps) => {
    try {
      const fanduUserId = localStorage.getItem("fanduUserId");

      if (!fanduUserId || totalTaps <= 0) return;

      const wrong = totalTaps - correct;

      // Correct tap = 2 points
      // Wrong tap = 1 point
      const totalPoints = correct * 2 + wrong * 1;

      const rewardedCount =
        Number(localStorage.getItem("numberRainRewardCount")) || 0;

      // Only first 5 games are rewarded
      if (rewardedCount >= 5) {
        return;
      }

      const fanduPayload = {
        user_id: fanduUserId,
        score: totalPoints,
        is_contest: isContest ? 1 : 0,
        remark: remark ? "Number Rain Contest" : "Number Rain",
      };

      const response = await updateFanduPoints(fanduPayload);

      const updatedPoints = Number(response?.score) || 0;

      localStorage.setItem("userFanduPoints", updatedPoints);

      localStorage.setItem("numberRainRewardCount", rewardedCount + 1);

      if (!response?.success) {
        ErrorHandling(response.message);
      }
    } catch (error) {
      console.error("Number Rain reward error:", error);
      ErrorHandling("Error updating points. Try again later.");
    }
  };

  const rules = [
    {
      key: "even",
      label: "Tap ONLY Even Numbers",
      check: (num) => num % 2 === 0,
    },
    {
      key: "odd",
      label: "Tap ONLY Odd Numbers",
      check: (num) => num % 2 !== 0,
    },
    {
      key: "multiple3",
      label: "Tap ONLY Multiples of 3",
      check: (num) => num % 3 === 0,
    },
    {
      key: "multiple5",
      label: "Tap ONLY Multiples of 5",
      check: (num) => num % 5 === 0,
    },
  ];

  const startGame = () => {
    const randomRule = rules[Math.floor(Math.random() * rules.length)];

    setRule(randomRule);

    setOpen(true);
    setGameOver(false);

    setScore(0);
    setTimeLeft(time);

    setNumbers([]);

    totalTapsRef.current = 0;
    correctRef.current = 0;

    avail("Number_Game_Open", page, "Click", "Screen_Impressions");
  };

  useEffect(() => {
    if (autoStart) {
      startGame();
    }
  }, []);

  useEffect(() => {
    correctRef.current = score;
  }, [score]);

  useEffect(() => {
    if (!open || gameOver) return;

    const timer = setInterval(() => {
      setTimeLeft((prev) => {
        if (prev <= 1) {
          clearInterval(timer);

          rewardNumberRainPoints(correctRef.current, totalTapsRef.current);

          setGameOver(true);

          return 0;
        }

        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [open, gameOver, score]);

  useEffect(() => {
    if (!open || gameOver) return;

    const interval = setInterval(() => {
      const newNumber = {
        id: Date.now() + Math.random(),
        value: Math.floor(Math.random() * 50) + 1,
        left: Math.random() * 82,
        rotate: Math.random() * 12 - 6,
      };

      setNumbers((prev) => [...prev, newNumber]);

      setTimeout(() => {
        setNumbers((prev) => prev.filter((item) => item.id !== newNumber.id));
      }, 4000);
    }, 700);

    return () => clearInterval(interval);
  }, [open, gameOver]);

  const handleTap = (item) => {
    const correct = rule.check(item.value);

    totalTapsRef.current += 1;

    if (correct) {
      setScore((prev) => prev + 1);
    }

    setNumbers((prev) => prev.filter((num) => num.id !== item.id));
  };

  return (
    <>
      {!autoStart && (
        <QuizCard
          onClick={startGame}
          title="Rain"
          image={catch1}
          bgColor="#cca5f3ff"
          buttonColor="#8e2fedff"
        />
      )}

      {open && (
        <div className={style.overlay}>
          <div className={style.card}>
            <div style={{ backgroundColor: "#1143b8" }}>
              <img
                src={logo}
                style={{ width: "120px", padding: "10px 20px" }}
              />
            </div>
            {!gameOver ? (
              <>
                <div className={style.header}>
                  <div className={style.score}>Score: {score}</div>

                  <div className={style.timer}>{timeLeft}s</div>
                </div>

                <div
                  className={style.progress}
                  style={{
                    width: `${(timeLeft / time) * 100}%`,
                  }}
                />

                <div className={style.ruleBox}>{rule?.label}</div>

                <div ref={containerRef} className={style.gameArea}>
                  {numbers.map((item) => (
                    <div
                      key={item.id}
                      className={style.number}
                      style={{
                        left: `${item.left}%`,
                        transform: `rotate(${item.rotate}deg)`,
                      }}
                      onClick={() => handleTap(item)}
                    >
                      {item.value}
                    </div>
                  ))}
                </div>
              </>
            ) : (
              <>
                <Confetti recycle={false} numberOfPieces={180} />
                <p className={style.resultTitle}>🎉 Time's Up</p>
                <div className={style.finalScore}>
                  {" "}
                  {correctRef.current * 2 +
                    (totalTapsRef.current - correctRef.current)}{" "}
                  FP
                </div>
                <p className={style.finalText}>Fandu Points Earned</p>
                <div className={style.bestScore}>Your Score: {score}</div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "10px",
                    padding: "0px 20px 20px 20px",
                  }}
                >
                  <button
                    className={style.submitBtn}
                    onClick={() => {
                      if (autoStart) onClose();
                      else {
                        setOpen(false);
                        avail(
                          "Math_Game_Close",
                          "Quiz_Categories",
                          "Click",
                          "Screen_Impressions",
                        );
                      }
                    }}
                  >
                    Close
                  </button>
                  <button
                    className={style.submitBtn}
                    style={{
                      background:
                        "linear-gradient(to bottom, #FF9130 0%, #EC7000 100%)",
                    }}
                    onClick={() => {
                      startGame();
                      avail(
                        "Math_Game_Restart",
                        "Quiz_Categories",
                        "Click",
                        "Screen_Impressions",
                      );
                    }}
                  >
                    Play Again
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
      )}
    </>
  );
}

export default NumberRain;

const QuizCard = ({ onClick, title, image, bgColor, buttonColor, avail }) => {
  return (
    <div
      className={style.quizCard}
      style={{
        background: `linear-gradient(to bottom, #FFFFFF, ${bgColor})`,
        border: `0.5px solid #EEEEEE`,
      }}
      onClick={() => onClick()}
    >
      <p className={style.quizTitle}>{title}</p>

      <div className={style.quizImageWrapper}>
        <img src={image} alt={title} className={style.quizImage} />
      </div>

      <div
        // type="button"
        className={style.quizButton}
        // style={{ backgroundColor: buttonColor }}
      >
        <FanduEarnBanner
          topText="Play &"
          bottomText="Earn"
          number={50}
          background={buttonColor}
          topTextColor="#FFFFFF"
          borderColor="#FAD140"
          bottomTextColor="#FAD140"
        />
      </div>
    </div>
  );
};
